var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"e-badge"},[_c('iconUsers'),_c('p',{staticClass:"e-badge__text"},[_vm._v(_vm._s(_vm.qty))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }